export class 
CustomQuestionAnswer { 
    public idCustomQuestionAnswer: number;
    public answer: string;
    public idCustomQuestion: number;
    public datetimeInclusion: Date;
}